/*
Sohel 12/23/2022 3075154998 Preprocessor new Ux Changes
Suresh Peddavoora  01/05/2023 3075154998 Changed Buttons Postions
kavyareddy 01/10/2023 3075154998 Fixed label issue
Sohel 01/10/2023 3075154998 fixed reset Issue
Ashraf 01/13/2023 3075154998 fixed page break issue
Akhila 01/16/2023 3075154998 rename Label description
Suresh Peddavoora 01/25/2023 3075154998 Fixed Card Spacing Alignments
Rohini 02/09/2023 3075154998 added classnames and enhancements in the text feilds
Prakash 02/14/2023 3075154998 Reverted New UI Changes
suresh peddavoora 02/22/2023 3075154998 New UI changes fixed
suresh peddavoora 02/24/2023 3075154998 New UI changes
Raghu 03/14/2023 3075154998 added class name for date picker
Prakash 03/20/2023 3075154998 fixed alignments issues.
Prakash 03/29/2023 3075154998 fixed Responsiveness issues.
Prakash 19-04-2023 3075154998 add margin top .
Akhila 04/25/2023 3075154998  Added usage and override functionality in transformation group
Ravi 05/16/2023 3075154998 Fixed page Break issue
Akhila 05/31/2023 3075154998 unsaved changes bug fixed
Akhila 06/08/2023 3075154998 created date change to date created field and column
Akhila 06/12/2023 3075154998 added role access
*/
import React, {useEffect, useState, useContext} from 'react';
import {Formik} from 'formik';
import SearchPreProcessorsGroupTable from './PreProcessorsGroupTable';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {TextField, Button, FormHelperText} from '@material-ui/core';
import PreprocessoreGroupUsage from './PreprocessoreGroupUsage';
import DialogBox from '../../../../../../components/DialogBox';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import * as Yup from 'yup';
const SearchProcessorForm = ({
  setShowSearch,
  setProcessorGroupCode,
  processorGroupCode,
  exportManagerRecord,
  managerRecordGroup = false,
  handleDirty,
  dmTempRecordAccess,
  editExisting,
  setDmProcessorGroupId=()=>{},
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const [preprocessorUsage, setPreprocessorUsage] = useState([]);
  const initialState = {
    groupName: processorGroupCode ? processorGroupCode : '',
    processorDescription: '',
    createdDate: null,
  };
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const [useAgeOpen, setUsageOpen] = useState(false);
  const handleUsageClose = () => {
    setUsageOpen(false);
  };
  useEffect(() => {
    setUsageOpen(false);
  }, []);
  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
  };
  const onClear = () => {
    const data = {
      groupName: '',
      processorDescription: '',
      createdDate: null,
    };
    setSearchData(data);
  };
  useEffect(() => {
    setSearchData({...initialState, groupName: processorGroupCode});
    setSubmit(true);
  }, [processorGroupCode]);
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialState}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {
            values,
            handleBlur,
            handleReset,
            handleSubmit,
            setFieldValue,
            touched,
            errors,
            dirty,
          } = props;
          if (dirty) {
            handleDirty(dirty);
          }
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields">
                <div className={`col-sm-6 col-xs-6 col-md-6 col-lg-3 col-xl-3`}>
                  <TextField
                    className={` ${classes.labelName} `}
                    placeholder="Enter Transformation Group Name"
                    margin="dense"
                    name="groupName"
                    variant="outlined"
                    value={values?.groupName}
                    label="Transformation Group Name"
                    onChange={(e) => {
                      setFieldValue('groupName', e.target.value);
                    }}
                    fullWidth
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 form-group">
                  <TextField
                    className={` ${classes.labelName} `}
                    placeholder="Enter Transformation Group Description"
                    margin="dense"
                    name="processorDescription"
                    value={values.processorDescription}
                    variant="outlined"
                    label="Transformation Group Description"
                    onChange={(e) => {
                      setFieldValue('processorDescription', e.target.value);
                    }}
                    fullWidth
                  />
                </div>

                <div className={`col-sm-6 col-xs-6 col-md-6 col-lg-2 col-xl-2`}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={` ${classes.labelName} account-date-picker`}
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      fullWidth
                      value={values.createdDate}
                      name="createdDate"
                      onBlur={handleBlur}
                      inputVariant="outlined"
                      helperText=""
                      label="Date Created"
                      onChange={(val) => {
                        setFieldValue('createdDate', val);
                      }}
                      autoOk
                      error={Boolean(touched?.createdDate && errors?.createdDate)}
                      margin="dense"
                    />
                  </MuiPickersUtilsProvider>
                  <FormHelperText variant="outlined">
                    {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                  </FormHelperText>
                </div>
                <div className="col-md-6 col-lg-3 form-group">
                  <div className=" d-flex">
                    <Button
                      variant="outlined"
                      className={`mr-1 reset-btn`}
                      onClick={() => {
                        handleReset();
                        setSubmit(true);
                        onClear();
                        setProcessorGroupCode('');
                        setDmProcessorGroupId(0);
                      }}
                    >
                      Reset
                    </Button>
                    <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                      Search
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
      <SearchPreProcessorsGroupTable
        setShowSearch={setShowSearch}
        searchData={searchData}
        submit={submit}
        setSubmit={setSubmit}
        setProcessorGroupCode={setProcessorGroupCode}
        processorGroupCode={processorGroupCode}
        exportManagerRecord={exportManagerRecord}
        managerRecordGroup={managerRecordGroup}
        setPreprocessorUsage={setPreprocessorUsage}
        useAgeOpen={useAgeOpen}
        setUsageOpen={setUsageOpen}
        handleUsageClose={handleUsageClose}
        handleDirty={handleDirty}
        editExisting={editExisting}
        dmTempRecordAccess={dmTempRecordAccess}
        setDmProcessorGroupId={setDmProcessorGroupId}
      />
      <DialogBox open={useAgeOpen} dialogClose={handleUsageClose} title="Usage" maxWidth="xl">
        <PreprocessoreGroupUsage
          preprocessorUsage={preprocessorUsage}
          handleUsageClose={handleUsageClose}
        />
      </DialogBox>
    </>
  );
};

export default SearchProcessorForm;
